<template>
  <div class="pb-5">
    <div v-if="object && object.id">
      <div class="row pt-2 document-pretable">
        <DocumentItemCol label="type"
                         :title="object.title"/>
        <DocumentItemCol label="warehouse"
                         :title="object.warehouse.title"/>
        <DocumentItemCol label="created"
                         v-if="object.user"
                         :title="object.user.full_name"/>
        <DocumentItemCol label="created"
                         :title="created_at"/>
        <DocumentItemCol label="status"
                         :title="$t(object.status)"/>
        <DocumentItemCol label="payment"
                         v-if="payMethod"
                         :title="payMethod"/>
        <DocumentItemCol label="comment"
                         v-if="object.comment"
                         :title="object.comment"/>
        <DocumentItemCol label="supplier"
                         v-if="object.supplier"
                         :title="object.supplier.title"/>
        <DocumentItemCol label="approved"
                         v-if="object.approved_user"
                         :title="object.approved_user.full_name"/>
        <DocumentItemCol label="approved"
                         v-if="approved_at"
                         :title="approved_at"/>
        <DocumentItemCol label="destination"
                         v-if="object.related && object.related.warehouse"
                         :title="object.related.warehouse.title"/>
      </div>
      <div class="data-table-wrapper pt-3">

<!--        NOT INVENTARIZATION-->
        <table class="table data-table"
               v-if="object.items_with_materials.length && type != 'inventarization'">
          <thead>
          <tr>
            <th>Id</th>
            <th>{{ $t('title') }}</th>
            <th>{{ $t('barcode') }}</th>
            <th>{{ $t('artikul') }}</th>
            <th>{{ $t('unit_of_measure') }}</th>
            <th>{{ $t('amount') }}</th>
            <th>{{ $t('price') }}</th>
            <th>{{ $t('sum') }}</th>
            <th v-if="editable"></th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(i, ind) in object.items_with_materials"
              :key="`op-item-${ind}`">
            <td :data-title="$t('id')">{{ i.id }}</td>
            <td :data-title="$t('name')" class="order-mob-0">
              {{ i.material.name }}
              <a v-b-popover.hover.html="quantityTitle(i.material)"
                 style="cursor: help"
                 v-if="object.warehouse && ['addition','write_off','consumption', 'consumption_manual', 'movement_from', 'movement_to'].includes(type)">
                <InfoSvg/>
              </a>
            </td>
            <td :data-title="$t('barcode')">{{ i.material.barcode }}</td>
            <td :data-title="$t('artikul')">{{ i.material.artikul }}</td>
            <td :data-title="$t('unit_of_measure')">{{ i.material.unit ? i.material.unit.title : units[i.material.unit_id] }}</td>
            <td :data-title="$t('amount')">
              <input v-if="editable"
                     @blur="changeFinish()"
                     @change="inputChanged = true"
                     v-model="i.readable_amount"
                     class="form-control"/>
              <span v-else>{{ i.readable_amount }}</span>
            </td>
            <td :data-title="$t('price')">
              <input v-if="editable"
                     @blur="changeFinish()"
                     @change="inputChanged = true"
                     v-model="i.price"
                     class="form-control"/>
              <span v-else>{{ formatNumber(i.price, true) }}</span>
            </td>
            <td :data-title="$t('total')">{{ formatCurrency(i.price * i.readable_amount) }}</td>
            <td v-if="editable"
                :data-title="$t('delete')">
              <a class="pointer"
                 @click="deleteItem(ind)">
                <DeleteSvg class="svg-stroke-light"/>
              </a>
            </td>
            <MobileMoreArrow/>
          </tr>
          <tr class="font-weight-bold">
            <td colspan="7">{{ $t('total') }}</td>
            <td :colspan="editable ? 2 : 1">{{ formatCurrency(total_sum) }}</td>
          </tr>
          </tbody>
        </table>

<!--        INVENTARIZATION-->
        <table class="table data-table" v-if="inventarizationItems.length">
          <thead>
          <tr>
<!--            <th></th>-->
            <th>{{ $t('title') }}</th>
            <th>{{ $t('barcode') }}</th>
            <th>{{ $t('artikul') }}</th>
            <th>{{ $t('factual_amount') }}</th>
            <th>{{ $t('warehouse_amount') }}</th>
            <th>{{ $t('difference') }}</th>
            <th>{{ $t('fact') }} ({{ getCurrencyName }})</th>
            <th>{{ $t('in_warehouse') }} ({{ getCurrencyName }})</th>
            <th>{{ $t('difference') }} ({{ getCurrencyName }})</th>
            <th v-if="editable"></th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(i, ind) in inventarizationItems"
              :key="`inv-item-${ind}`">
<!--            <td :data-title="'#'">{{ind + 1 }}</td>-->
            <td :data-title="$t('name')" class="order-mob-0">{{ i.material.name }}</td>
            <td :data-title="$t('barcode')">{{ i.material.barcode }}</td>
            <td :data-title="$t('artikul')">{{ i.material.artikul }}</td>
            <td :data-title="$t('factual_amount')">
              <input class="form-control"
                     type="number"
                     @change="save(false)"
                     :readonly="!editable"
                     v-model="i.counted_amount"/>
            </td>
            <td :data-title="$t('warehouse_amount')">{{ i.warehouse_amount }}</td>
            <td :data-title="$t('difference')"><span :class="{ 'text-danger': invDifference(i) != 0 }">{{ invDifference(i) }}</span></td>
            <td :data-title="`${$t('fact')} ${getCurrencyName}`">{{ formatNumber(i.price * i.counted_amount) }}</td>
            <td :data-title="`${$t('in_warehouse')} ${getCurrencyName}`">{{ formatNumber(i.price * i.warehouse_amount) }}</td>
            <td :data-title="`${$t('difference')} ${getCurrencyName}`"><span :class="{ 'text-danger': invDifference(i) != 0 }">{{ formatNumber(invDifference(i) * i.price) }}</span></td>
            <td v-if="editable"
                :data-title="$t('delete')">
              <a class="pointer" @click="deleteInvItem(ind)"><DeleteSvg class="svg-stroke-light"/></a>
            </td>
            <MobileMoreArrow/>
          </tr>
          </tbody>
          <tfoot>
          <tr>
            <th>{{ $t('total') }}</th>
            <th colspan="2"></th>
            <th>{{ inventarizationTotals.counted_amount }}</th>
            <th>{{ inventarizationTotals.warehouse_amount }}</th>
            <th><span :class="{ 'text-danger': inventarizationTotalDifference != 0 }">{{ inventarizationTotalDifference }}</span></th>
            <th>{{ formatNumber(inventarizationTotals.counted_sum) }}</th>
            <th>{{ formatNumber(inventarizationTotals.warehouse_sum) }}</th>
            <th><span :class="{ 'text-danger': inventarizationSumDifference != 0 }">{{ formatNumber(inventarizationSumDifference) }}</span></th>
            <th v-if="editable"></th>
          </tr>
          </tfoot>
        </table>

        <div v-if="type === 'inventarization' && !documentIsApproved"
             class="mb-3">
          <b-dropdown variant="link"
                      :text="$t('bulk_addition')"
                      toggle-class="btn-themed btn-themed-outline btn-themed-squared px-4 d-inline-block">
            <b-dropdown-item @click="addAllMaterialsForInventarization()"
                             link-class="font-weight-bold">
              {{ $t('add_all_materials_from_warehouse') }}
            </b-dropdown-item>
            <b-dropdown-divider/>
            <b-dropdown-group :header="$t('by_categories')">
              <b-dropdown-item v-for="category in categories"
                               :key="`cat-${category.id}`"
                               @click="addAllMaterialsForInventarization(category.id)">
                {{ category.title }}
              </b-dropdown-item>
            </b-dropdown-group>
          </b-dropdown>
        </div>
        <div class="row no-print row-narrow" v-if="editable">
          <div class="col-md-auto col">
            <Autocomplete :placeholder="$t('enter_title_or_barcode')"
                          model="material"
                          class="autocomplete-operation-material"
                          v-model="autocompleteMaterial"/>
          </div>
          <div class="col col-md col-auto">
            <button @click="save"
                    :disabled="loading"
                    class="btn-themed btn-themed-outline btn-themed-squared d-inline-block">
              {{ $t('save') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import InfoSvg from '@/assets/svg-vue/general/info2.svg'
import { useStore } from "vuex"
import DocumentItemCol from "@/components/parts/warehouse/DocumentItemCol"
import moment from "moment"
import Autocomplete from "@/components/parts/general/Autocomplete"
import DeleteSvg from '@/assets/svg-vue/general/delete2.svg'
import MobileMoreArrow from "@/components/parts/datatable/MobileMoreArrow"
import { WarehouseService } from "@/services/api/warehouse.api.service"
import {formatCurrency, formatNumber} from "@/extensions/filters/filters"
import {computed, getCurrentInstance, onBeforeMount, onBeforeUnmount, onMounted, ref, watch} from "vue"
import {useHead} from "@unhead/vue"
import {useRoute} from "vue-router"

const store = useStore()
const route = useRoute()

let i18n = null
let noty = null

const object = computed(() => store.state.warehouseoperation.operation)
const title = computed(() => `Документ # ${object.value?.id || ''}`)

useHead({
  title: () => title.value,
})

const autocompleteMaterial = ref(null)
const inputChanged = ref(false)
const fillingDocument = ref(false)
const categories = ref([])
const loading = computed(() => store.state.dom.loading)
const counter = computed(() => store.state.datatable.dataTableCounter)
const newEloquentObject = computed(() => store.state.datatable.newEloquentObject)
const pay_methods = computed(() => store.state.auth.pay_methods)
const units = computed(() => store.state.auth.units)
const type = computed(() => object.value?.operation_type || '')
const inventarizationItems = computed(() => {
  return (object.value?.warehouse_inventarization_sheets || []).map(item => {
    item.price = documentIsApproved.value ? (object.value.items_with_materials.find(o => o.material_id === item.material_id)?.price || item.material.price) : item.material.price
    return item
  })
})
const inventarizationTotals = computed(() => {
  const warehouse_amount = object.value?.warehouse_inventarization_sheets.reduce((acc, curr) => acc + Number(curr.warehouse_amount), 0)
  const warehouse_sum = inventarizationItems.value.reduce((acc, curr) => acc + Number(curr.warehouse_amount) * curr.price, 0)
  const counted_amount = object.value?.warehouse_inventarization_sheets.reduce((acc, curr) => acc + Number(curr.counted_amount), 0)
  const counted_sum = inventarizationItems.value.reduce((acc, curr) => acc + Number(curr.counted_amount) * curr.price, 0)
  return {
    warehouse_amount,
    warehouse_sum,
    counted_amount,
    counted_sum
  }
})
const getCurrencyName = computed(() => store.getters.getCurrencyName)
const inventarizationTotalDifference = computed(() => inventarizationTotals.value.counted_amount - inventarizationTotals.value.warehouse_amount)
const inventarizationSumDifference = computed(() => inventarizationTotals.value.counted_sum - inventarizationTotals.value.warehouse_sum)
const created_at = computed(() => object.value.date_timezone ? moment(object.value.date_timezone).format('DD.MM.YYYY, HH:mm') : '')
const approved_at = computed(() => object.value.approved_timezone ? moment(object.value.approved_timezone).format('DD.MM.YYYY, HH:mm') : '')
const editable = computed(() => object.value?.status === 'draft' && type.value !== 'movement_to')
const total_sum = computed(() => object.value.items_with_materials.reduce((acc, curr) => acc + (curr.readable_amount * curr.price), 0))
const payMethod = computed(() => {
  if(!object.value.forma) return null
  const pm = pay_methods.value.find(p => p.id === Number(object.value.forma))
  return pm?.translatedTitle || pm?.title || null
})
const documentIsApproved = computed(() => object.value?.status === 'finished')

onBeforeMount(() => {
  const instance = (getCurrentInstance())
  i18n = instance?.ctx?.$i18n
  noty = instance?.appContext?.app?.noty
})

onMounted(async () => {
  await store.dispatch('getDocument', route.params.id)
  if(type.value === 'inventarization') {
    categories.value = (await WarehouseService.getCategoriesWithMaterials())?.data || []
  }
})

const deleteItem = (index) => {
  store.dispatch('deleteDocumentItem', index)
}

const deleteInvItem = (index) => {
  store.dispatch('deleteInventarizationItem', index)
}

const save = async (message = true) => {
  if(loading.value) return
  try {
    const res = await store.dispatch('saveDocument')
    if(res?.message) {
      noty.error(res?.message)
      return
    }
  } catch (e) {
    noty.error(e.message)
    return
  }
  if(message) noty.info(i18n.t('success_message'))
  inputChanged.value = false
}

const changeFinish = () => {
  if(inputChanged.value) {
    save(false)
  }
}

const addAllMaterialsForInventarization = async (categoryId = null) => {
  if(loading.value || fillingDocument.value) return
  fillingDocument.value = true
  try {
    await store.dispatch('fillInventarization', { categoryId })
  } finally {
    fillingDocument.value = false
  }

}

const invDifference = (i) => {
  return Number(i.counted_amount) - Number(i.warehouse_amount)
}

const quantityTitle = (material) => {
  return `${i18n.t('warehouse_amount')} "${object.value?.warehouse?.title || ''}": <b>${material.quantities?.[object.value.warehouse_id] || 0}</b>`
}

watch(autocompleteMaterial, (val) => {
  if(val) {
    if(type.value === 'inventarization') {
      store.dispatch('addInventarizationItem', {
        material_id: val.id,
      })
      autocompleteMaterial.value = null
      return
    }
    store.dispatch('addDocumentItem', {
      material_id: val.id,
      price: val.price,
      amount: 1,
    })
  }
})

watch(counter, () => {
  store.dispatch('getDocument', route.params.id)
})

watch(newEloquentObject, (val) => {
  if(val?.material_id) {
    store.dispatch('addDocumentItem', {
      operationId: route.params.id, // this we add because counter changes and operation becomes null
      material_id: val.material_id,
      price: val.price,
      amount: 1,
    })
  }
})

onBeforeUnmount(() => {
  store.commit('setOperation', null)
})
</script>

<style scoped lang="scss">
.document-pretable {
  font-size: 14px;
}
.data-table-wrapper {
  input.form-control {
    max-width: 100px;
    height: 32px;
  }
  td, th {
    vertical-align: middle;
  }
}
.btn-themed {
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
@media screen and (max-width: 768px) {
  .table th {
    border-top: none;
  }
}
</style>
